import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class LinesOfActionState extends PlayerOrNoneGameStateWithTable {
    static SIZE = 8; // board size
    static isOnBoard(coord) {
        return coord.isInRange(LinesOfActionState.SIZE, LinesOfActionState.SIZE);
    }
}
